/**
 * Feature flags configuration
 * Controls which features are enabled based on the environment
 * 
 * Stripe/Billing features are automatically disabled in production
 * (platform.earthpbc.com) until Stripe keys are properly configured.
 * 
 * Features controlled:
 * - Billing page visibility in organization menu
 * - Upgrade/payment buttons in UI
 * - Customer portal access
 * - Payment link generation
 * - Billing route access
 */

// Detect if we're in production based on the hostname
const isProduction = window.location.hostname === 'platform.earthpbc.com'

// Feature flags
export const features = {
  // Stripe/Billing features - disabled in production until fully configured
  stripe: {
    enabled: !isProduction,
    showBillingPage: !isProduction,
    showUpgradeButtons: !isProduction,
    showPaymentLinks: !isProduction,
    showCustomerPortal: !isProduction
  }
}

// Helper function to check if a feature is enabled
export const isFeatureEnabled = (featurePath) => {
  const paths = featurePath.split('.')
  let current = features
  
  for (const path of paths) {
    if (current[path] === undefined) {
      return false
    }
    current = current[path]
  }
  
  return current === true || (typeof current === 'object' && current.enabled === true)
}